import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { NotificationService } from "app/main/shared/services/notification.service";
import { BehaviorSubject } from "rxjs";

@Injectable({
  providedIn: "root"
})
export class BookOrderService {
  currentOrder: BehaviorSubject<any> = new BehaviorSubject({});

  constructor(
    private _http: HttpClient,
    private _router: Router,
    public _notification: NotificationService
  ) {}

  bookOrder(order): void {
    this.currentOrder.next(order);
    // this._router.navigate(["actions", "book-order", order?.SG_ORDERID]);

    this._router.navigateByUrl(
      `actions/book-order/${order?.shipmentType.toLowerCase()}/${
        order.SG_ORDERID
      }`
    );
  }

  getOrder(body): void {
    this._http.post("user/order/singleOrder", body).subscribe((res: any) => {
      if (res.success) {
        this.currentOrder.next(res.orders);
      } else {
        this.currentOrder.next({});
        this._notification.show(res.msg);
      }
    });
  }

  editOrderApi = (body) => this._http.post("user/order/editOrder", body);
  getCourierPrices = (body) => this._http.post("user/order/orderPrice", body);
  bookOrderApi = (body) => this._http.post("user/order/bookOrder", body);
}
